import { useBroadcastChannel } from '@vueuse/core';

export const useUserProfile = (): Ref<AppUserProfile> => {
    return useState<AppUserProfile>('appUserProfile');
}

export const updateProfilePersonalData = async (data) => {
    const updatedProfile = await $fetch<AppUserProfile>('/api/user/changeBasicUserData', {
        method: 'POST',
        body: data,
    });

    updateAppUserProfileState(updatedProfile);
}

export const updateUserAddress = async (data) => {
    const updatedProfile = await $fetch<AppUserProfile>('/api/user/address/update', {
        method: 'POST',
        body: data,
    });

    updateAppUserProfileState(updatedProfile);
}

function updateAppUserProfileState(profile: AppUserProfile | undefined) {
    if (profile) {
        useState('appUserProfile').value = profile;
        broadcastProfileUpdate();
    }
}

function broadcastProfileUpdate() {
    const { isSupported: isBroadcastSupported, post: postSessionChange } = useBroadcastChannel({
        name: 'user-profile-channel',
    });

    if (isBroadcastSupported) {
        postSessionChange(Date.now());
    }
}

export const getGenderLabel = (rawValue: Gender | string) => {
    if (typeof rawValue === 'string') {
        if (rawValue === 'MS') rawValue = 'FEMALE';
        if (rawValue === 'MR') rawValue = 'MALE';
        rawValue = Gender[rawValue.toUpperCase() as keyof typeof Gender];
    }

    switch (rawValue) {
        case Gender.FEMALE:
            return 'Frau';
        case Gender.MALE:
            return 'Herr';
        case Gender.DIVERSE:
            return 'Divers';
        case Gender.COMPANY:
            return 'Firma';
        case Gender.FAMILY:
            return 'Familie';
        case Gender.UNKNOWN:
        default:
            return 'Unbekannt';
    }
};
